import { configureStore } from '@reduxjs/toolkit';
import quickPayReducer from './reducers/quickPay';
export const storeOptions = {
    reducer: {
        quickPay: quickPayReducer,
    },
};
const store = configureStore(storeOptions);
export default store;
